import { type IInvestorCashflowCalculationInputs, InvestorCashflow, type InvestorCashflowType } from '@condo/domain';
import { getClient } from './api-client';

export interface IFetchInvestorCashflowParams {
    page?: number;
    size?: number;
    type?: InvestorCashflowType[];
    onlyLatestPredictions?: boolean;
}

export const fetchInvestorCashflowsForEstate = async (
    estateId: number,
    params?: IFetchInvestorCashflowParams,
): Promise<{ investorCashflows: InvestorCashflow[]; count: number }> =>
    getClient('basecamp')
        .get(`/estates/${estateId}/investor-cashflows`, { params })
        .then(({ data }) => ({ investorCashflows: data.investorCashflows.map(dto => new InvestorCashflow(dto)), count: data.count }));

export const getInvestorCashflow = async (estateId: number, investorCashflowId: number): Promise<InvestorCashflow> =>
    getClient('basecamp')
        .get(`/estates/${estateId}/investor-cashflows/${investorCashflowId}`)
        .then(({ data }) => new InvestorCashflow(data.investorCashflow));

export const recalculateInvestorCashflow = async (
    investorCashflowId: number,
    inputs?: Partial<IInvestorCashflowCalculationInputs>,
    opts?: { persistAfterRecalculation?: boolean; fullRecalculation?: boolean },
): Promise<InvestorCashflow> =>
    getClient('basecamp')
        .post(`/investor-cashflows/${investorCashflowId}/recalculate`, { inputs, ...(opts ?? {}) })
        .then(({ data }) => new InvestorCashflow(data.investorCashflow));

export const createInvestorCashflowForInvestment = async (investmentId: number): Promise<InvestorCashflow> =>
    getClient('basecamp')
        .post(`/investor-cashflows/investments/${investmentId}`)
        .then(({ data }) => new InvestorCashflow(data.investorCashflow));

export const createInvestorCashflowForPrediction = async (predictionId: number): Promise<InvestorCashflow> =>
    getClient('basecamp')
        .post(`/investor-cashflows/predictions/${predictionId}`)
        .then(({ data }) => new InvestorCashflow(data.investorCashflow));

export const generateInvestorCashflowSheet = async (investorCashflowId: number): Promise<{ sheetLink: string }> =>
    getClient('basecamp')
        .post(`/investor-cashflows/${investorCashflowId}/sheet`)
        .then(({ data }) => data);
